'use strict';
var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-object.js
// module id = 20
// module chunks = 0